var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercialAssests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 557.04 589.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #505050;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 17.86px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-dasharray: 0 0 4.03 35.42;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "191.18 539.63 191.18 8.93 39.86 94.37 39.86 539.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "247.12 539.63 191.18 539.63 191.18 8.93 342.5 79.72 342.5 122.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 494.04 191.18 487.63 247.12 489.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 449.18 191.18 434.5 247.12 439"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 404.31 191.18 381.31 247.12 388.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 359.45 191.18 328.11 247.12 337.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 314.58 191.18 274.91 247.12 287.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 269.72 191.18 221.71 247.12 236.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 224.86 191.18 168.52 247.12 185.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 179.99 191.18 115.32 290.91 150.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.86 135.13 191.18 62.12 342.5 122.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "399.91 539.63 399.91 128.35 282.64 194.56 282.64 539.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "399.91 539.63 399.91 128.35 517.18 183.21 517.18 539.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 504.3 399.91 499.33 517.18 503.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 469.53 399.91 458.16 517.18 467.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 434.76 399.91 416.93 517.18 431.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 399.99 399.91 375.71 517.18 395.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 365.23 399.91 334.48 517.18 359.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 330.46 399.91 293.25 517.18 324.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 295.69 399.91 252.03 517.18 288.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 260.92 399.91 210.8 517.18 252.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "282.64 226.15 399.91 169.58 517.18 216.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.93,
    y1: 539.63,
    x2: 548.11,
    y2: 539.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 267.76,
    y1: 580.36,
    x2: 497.87,
    y2: 580.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.17,
    y1: 580.36,
    x2: 133.98,
    y2: 580.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "178.91 580.36 213.88 580.36 230.32 580.36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialAssests);
export default __webpack_public_path__ + "static/media/commercial-assests.4bc837ea4d804f4054ab2006f72c96e7.svg";
export { ForwardRef as ReactComponent };